import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import WorkCard from "@/components/WorkCard";
import WorkModal from "@/components/WorkModal";
import { WORK_ITEMS } from "@/data/work";

export default function Work() {
  const [active, setActive] = useState(null);

  return (
    <main data-testid="work-page" className="pt-40 pb-28">
      <Seo
        title="Work — Fredline Studios"
        siteName="Fredline Studios"
        description="Selected website concepts engineered by Fredline Studios: NEXA, RIDGELINE and APEX."
        image="/images/concept-apex.png"
      />

      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <span className="mono-label">THE ARCHIVE</span>
          <h1 className="font-display metal-text mt-4 max-w-3xl text-5xl font-black leading-[0.95] tracking-tighter sm:text-7xl">
            PROOF, NOT PROMISES.
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-400">
            A selection of concept builds from the studio. Click any piece for the full breakdown — strategy, stack, and outcome.
          </p>
        </Reveal>

        <div className="mt-20 flex flex-col gap-16">
          {WORK_ITEMS.map((item, i) => (
            <div key={item.id} className={i % 2 === 1 ? "lg:ml-auto lg:w-[88%]" : "lg:w-[88%]"}>
              <span className="mono-label mb-4 block text-slate-600">PROJECT /{String(i + 1).padStart(2, "0")}</span>
              <WorkCard item={item} index={0} onOpen={setActive} />
            </div>
          ))}
        </div>

        <Reveal className="mt-28 border border-[#1E2335] bg-[#0D0E15] p-10 text-center sm:p-16">
          <span className="mono-label">YOUR PROJECT HERE</span>
          <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-slate-100 sm:text-5xl">
            Slot /04 is open.
          </h2>
          <Link
            to="/contact"
            data-testid="work-cta-button"
            className="mt-10 inline-flex items-center gap-2 bg-cyan-400 px-8 py-4 font-mono text-[12px] font-bold tracking-[0.2em] text-[#07080C] uppercase transition-all duration-200 hover:bg-cyan-300 hover:shadow-[0_0_40px_rgba(0,240,255,0.45)] active:scale-[0.97]"
          >
            Claim It
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>

      <WorkModal item={active} onClose={() => setActive(null)} />
    </main>
  );
}
